import * as React from 'react';

import { DropdownField } from '../../../components/dropdownField';

import { EParkingType } from '../../../../../../../json_query';

interface IParkingProps {
  value: EParkingType[];
  onChange(value: EParkingType[]): void;
}

enum EParking {
  Any,
  Open,
  Closed,
}

const OPTIONS = [
  { value: EParking.Open, label: 'Открытая' },
  { value: EParking.Closed, label: 'Закрытая' },
];

export class Parking extends React.Component<IParkingProps> {
  public render() {
    return (
      <DropdownField
        multiple
        value={this.getValue()}
        onValueChange={this.handleChange}
        values={OPTIONS}
        placeholder="Неважно"
      />
    );
  }

  private handleChange = (value: EParking[]) => {
    const result = [];

    if (value.includes(EParking.Open)) {
      result.push(EParkingType.Ground, EParkingType.Rooftop);
    }

    if (value.includes(EParking.Closed)) {
      result.push(EParkingType.Underground, EParkingType.Multilevel);
    }

    this.props.onChange(result);
  };

  private getValue = () => {
    const { value } = this.props;
    const result = [];

    if (value.includes(EParkingType.Ground) || value.includes(EParkingType.Rooftop)) {
      result.push(EParking.Open);
    }

    if (value.includes(EParkingType.Underground) || value.includes(EParkingType.Multilevel)) {
      result.push(EParking.Closed);
    }

    return result;
  };
}
